const errorContainsCode = ({
  code,
  err,
}: {
  code: number | string;
  err: unknown;
}): boolean => {
  const codeStr = String(code);
  try {
    if (typeof err === "string") return err.includes(codeStr);
    if (err instanceof Error) return String(err).includes(codeStr);
    const serialized = JSON.stringify(err);
    return serialized.includes(codeStr);
  } catch {
    return false;
  }
};

export { errorContainsCode };
